import { createClient } from '@supabase/supabase-js';

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey     = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseService = process.env.REACT_APP_SUPABASE_SERVICE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error(
    '❌ Missing Supabase credentials.\n' +
    'Create a .env file from .env.example and fill in your project URL and anon key.'
  );
}

// Standard client — used everywhere (respects RLS)
export const supabase = createClient(supabaseUrl, supabaseKey);

// Admin client — singleton to prevent multiple GoTrueClient instances
// Uses service_role key which bypasses RLS and email confirmation
let _supabaseAdmin = null;
export const supabaseAdmin = (() => {
  if (!supabaseService) return null;
  if (!_supabaseAdmin) {
    _supabaseAdmin = createClient(supabaseUrl, supabaseService, {
      auth: { autoRefreshToken: false, persistSession: false, storageKey: 'sb-admin-auth' },
    });
  }
  return _supabaseAdmin;
})();
